import { Box, Card, CardContent } from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCard = styled(Card)({
  height: "100%",
  minHeight: 250,
});

export const StyledCardContent = styled(CardContent)(() => ({
  padding: 0,
  ":last-child": {
    padding: 0,
  },
}));

export const StyledCenteredBox = styled(Box)(() => ({
  height: "100%",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
}));
